/**
 * @desc 公司ComeOnDetail统计接口
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.CompanyComeOnStatisticalSubsidiaryConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.TheCompanyComeOnDetailedInformation>>>> {
  return fetch({
    url: config.API_HOST + '/statistics/getCompanyPetrolDetailStatPage',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
